import { render } from "./App.vue?vue&type=template&id=51a0327e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=51a0327e&lang=scss"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/A Storm Is Blowing From Paradise/a-storm-v5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__